import React from "react";

import { useHistory } from "react-router-dom";

import { MenuItemListDto } from "services/menu/restModels";

import { localizedText } from "shared/lib/localizedMap";
import {
    ActionMenu,
    ActionMenuItem,
    CopyIcon,
    DeleteIcon,
    EditIcon,
    MoveIcon,
} from "shared/ui";

import { useMenuEditorContext } from "features/MenuEditor/context";

interface ItemActionsMenuProps {
    item: MenuItemListDto | null;
    anchorEl: HTMLElement | null;
    onClose: () => void;
}

export const ItemActionsMenu = ({ item, anchorEl, onClose }: ItemActionsMenuProps) => {
    const state = useMenuEditorContext();
    const history = useHistory();

    if (!item) return null;

    const actions: ActionMenuItem[] = [
        {
            key: "edit",
            icon: <EditIcon />,
            label: "Редактировать",
            onClick: () =>
                history.push(
                    `/menus/regular/${state.menuId}/${item.menuCategoryId}/${item.id}`
                ),
        },
        {
            key: "copy",
            icon: <CopyIcon />,
            label: "Копировать в меню…",
            onClick: () => state.openDialog({ kind: "copyItem", item }),
        },
        {
            key: "move",
            icon: <MoveIcon />,
            label: "Перенести в категорию…",
            onClick: () => state.openDialog({ kind: "moveItem", item }),
        },
        {
            key: "delete",
            icon: <DeleteIcon />,
            label: "Удалить позицию",
            tone: "danger",
            separated: true,
            onClick: () => state.openDialog({ kind: "deleteItem", item }),
        },
    ];

    return (
        <ActionMenu
            open
            anchorEl={anchorEl}
            title={localizedText(item.name, state.locale)}
            items={actions}
            onClose={onClose}
        />
    );
};
